import { render, staticRenderFns } from "./ChooseLg.vue?vue&type=template&id=37a5c056&scoped=true&"
import script from "./ChooseLg.vue?vue&type=script&lang=js&"
export * from "./ChooseLg.vue?vue&type=script&lang=js&"
import style0 from "./ChooseLg.vue?vue&type=style&index=0&id=37a5c056&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a5c056",
  null
  
)

export default component.exports